import {
    UserApplicant,
    UserApplicantAsset,
    UserApplicantDebt,
    UserApplicantEmployment,
    UserApplicantFinancial,
    UserApplicantIncome,
    UserApplicantPersonal,
    UserApplicantProperty,
    UserApplicantTax,
    UserMortgage,
    UserMortgageExisting,
    UserMortgageNeeds,
    UserMortgageProperty,
    UserMortgageRequirement,
    UserMortgageUploads
} from '../models';
import personal from "./section-questions/applicant/personal";
import employment from "./section-questions/applicant/employment";
import income from "./section-questions/applicant/income";
import needs from "./section-questions/mortgage/needs";
import property from "./section-questions/mortgage/property";
import existing from "./section-questions/mortgage/existing";
import properties from "./section-questions/applicant/properties";
import assets from "./section-questions/applicant/assets";
import debts from "./section-questions/applicant/debts";
import setup, {calc} from "./section-questions/mortgage/setup";

export const modelClasses = {
    applicant: UserApplicant,
    personal: UserApplicantPersonal,
    employment: UserApplicantEmployment,
    income: UserApplicantIncome,
    debts: UserApplicantDebt,
    assets: UserApplicantAsset,
    properties: UserApplicantProperty,
    needs: UserMortgageNeeds,
    property: UserMortgageProperty,
    existing: UserMortgageExisting,
    tax: UserApplicantTax,
    financial: UserApplicantFinancial,
    requirement: UserMortgageRequirement,
    uploads: UserMortgageUploads,
    mortgage: UserMortgage
}
export function getSetupSections(props) {

    function mortgageSections(myProps) {
        if (props.mortgage.mortgageType === 'REFINANCE') {
            return [
                needs(myProps),
                existing(myProps),
                property(myProps)
            ]
        }
        return [
            needs(myProps),
            property(myProps)
        ]
    }
    let sections = [setup(props), ...mortgageSections(props)];

    return prepareSections(sections, 'SETUP')
}
export function getCalcSections(props) {
    return prepareSections([calc(props)], 'setup')
}
export function getTasksSections(props) {
    return []
}
export function getApplySections(props) {
    let sections = []
    function applicantSections(myProps) {
        return [
            personal(myProps),
            employment(myProps),
            income(myProps),
            properties(myProps),
            assets(myProps),
            debts(myProps)
        ]
    }

    if ((props.mortgage.twoApplicants === true || props.mortgage.twoApplicants === false) && props.mortgage.mortgageType) {
        sections = applicantSections({...props, ...{applicant: 1}})
        if (props.mortgage.twoApplicants) {
            sections = sections.concat(applicantSections({...props, ...{applicant: 2}}))
        }

    }
    return prepareSections(sections, 'APPLY')
}
export function getSectionInstance(section, modelName) {
    if (section.applicant) {
        if (modelName === 'applicant') {
            return section.props.mortgage['applicant' + section.applicant]
        }
        return section.props.mortgage['applicant' + section.applicant][modelName]
    }
    if (modelName === 'mortgage') {
        return section.props.mortgage
    }
    return section.props.mortgage[modelName]
}
export function getSectionInstances(section) {
    const instances = {}
    if (!section) {
        return false
    }
    for (const model of section.models) {
        instances[model] = getSectionInstance(section, model)
    }
    return instances
}
export function prepareSections(sections, stage) {
    return sections.map(section => {
        let root = section.name
        const parts = root.split('-')
        let applicant = false;
        if (!isNaN(parts[parts.length - 1])) {
            applicant = parseInt(parts.pop())
            root = parts.join('')
        }
        const usedModels = []
        section.questions.forEach(question => {
            if (!usedModels.includes(question.model)) {
                usedModels.push(question.model)
            }
        })

        const newSection = {
            ...section,
            ...{
                stage: stage,
                root: root,
                applicant: applicant,
                models: usedModels,
                link: section.link
            }
        }
        //newSection.instances = getSectionInstances(newSection)
        return newSection
    })
}